export default {"src":"/_next/static/media/carOutline75_40.23b398a3.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};